<template>
  <div>
    <shield-modal
      :id="`connection-approval-modal-${connection.uuid}`"
      :size="'sm'"
      @handleCancel="handleDecline"
      @handleSubmit="handleApprove"
      :enableSubmit="true"
      submitButtonClass="green-button">
      <template #title>
        <h5 class="modal-title shield-modal">
          <p class='header-text'>Approve Connection</p>
        </h5>
        
      </template>
      <template #default>
        <div class="connection-approval text-center">
          <p class="mb-4">A new agent wants to connect with you!</p>
          <h3>{{ connection.model_first_name }} {{ connection.model_last_name }}</h3>
          <p><u> {{ connection.model_email }}</u></p>
        </div>
      </template>
      <template #cancel-btn>Decline</template>
      <template #submit-btn>Connect</template>
    </shield-modal>
  </div>
</template>

<script>
import ShieldModal from '@components/modals/ShieldModal/ShieldModal';
import UserMixin from '@mixins/UserMixin';
import { CONNECTION_PENDING, CONNECTION_ACCEPTED } from '@helpers/connections';

export default {
  name: 'ConnectionApprovalModal',
  components: {
    ShieldModal
  },
  mixins: [UserMixin],
  props: {
    connection: {
      type: Object,
      required: true
    }
  },
  methods: {
    async handleDecline() {
      if (this.connection.status === CONNECTION_PENDING) {
        await this.me.disconnectConnection(this.connection.uuid);
      }
      this.$emit('declined', this.connection);
      this.$bvModal.hide(`connection-approval-modal-${this.connection.uuid}`);
    },
    async handleApprove() {
      if (this.connection.status === CONNECTION_PENDING) {
        await this.me.accept(this.connection.uuid, true);
      }
      this.$emit('approved', this.connection);
      this.$bvModal.hide(`connection-approval-modal-${this.connection.uuid}`);
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss">
@import './ConnectionApprovalModal.scss';

// You can add any additional component-specific styles here if needed
</style>